import { render, staticRenderFns } from "./hqStuHealthActivities.vue?vue&type=template&id=33ff6a62&scoped=true"
import script from "./hqStuHealthActivities.vue?vue&type=script&lang=js"
export * from "./hqStuHealthActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff6a62",
  null
  
)

export default component.exports